export enum VisitPlanDatasourceEnum {
  Configuration = "Configuration",
  Prediction = "Prediction",
  Manual = "Manual",
  Actual = "Actual"
}
